    import React, { useEffect, useState, useRef } from 'react';
import MultiSelectEntity from '../RefineSearch/TgMultiSelectEntity';
import FilterWrapper from './FilterWrapper';
import { filterPESector } from "../../Config/config";
import useScrollIntoView from './useScrollIntoView';

function SectorFilter({ open, accordionClick, options, setOptions, customPathname, label }) {
    const [sectorVal, setSectorVal] = useState("");
    const [fetchedData, setFetchedData] = useState([]);
    const [isFocused, setIsFocused] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);
    const inputRef = useRef(null);
    const dropdownRef = useRef(null);
    const shouldScroll = open || fetchedData.length > 0;
    const listItemRef = useScrollIntoView(shouldScroll);

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            if (sectorVal.trim() !== "") {
                fetchData();
            } else {
                setShowDropdown(false);
            }
        }, 300);

        return () => clearTimeout(delayDebounceFn);
    }, [sectorVal]);

    const fetchData = () => {
        const payload = {
            search_key: sectorVal,
        };

        fetch(filterPESector, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then(data => {
            if (data?.results) {
                setFetchedData(data?.results); // Store fetched data
                setShowDropdown(true);
            }
        })
        .catch(error => {
            console.error('Error fetching data:', error);
            setFetchedData([]);
            setShowDropdown(false);
        });
    };

    useEffect(() => {
        const uniqueFetchedData = fetchedData;
        setOptions(prevOptions => [...prevOptions.filter(item => item.isChecked === true), ...uniqueFetchedData]);
    }, [fetchedData]);

    const handleSectorChange = (e) => {
        const { name, checked, id } = e.target;
        let currentSectors = [];

        if (name === "allSelect") {
            currentSectors = options.map((sector) =>
                ({ ...sector, isChecked: checked })
            );
            setOptions(currentSectors);
        } else {
            currentSectors = options.map((sector) =>
                sector.id === id ? { ...sector, isChecked: checked } : sector
            );
            setOptions(currentSectors);
        }
    };

    const selectedSectorLength = options?.filter(option => option.isChecked)?.length ?? 0;
    const hasValue = sectorVal || selectedSectorLength > 0;

    return (
        <div className="relative">
            {/* Search Results Dropdown - Positioned BELOW the input */}
            {showDropdown && fetchedData.length > 0 && (
                <div 
                    ref={dropdownRef} 
                    className="absolute z-50 w-full md:w-[90%] top-full mt-1 bg-white border border-gray-100 rounded-sm shadow-lg max-h-64 overflow-y-auto"
                >
                    <MultiSelectEntity
                        fetchData={fetchData}
                        handleEntityChange={handleSectorChange}
                        primaryEntity={options}
                        setCompanyVal={setSectorVal}
                        field="sector"
                        hideSearchInput={true}
                    />
                </div>
            )}
            
            <div className={`absolute left-3 transition-all duration-200 pointer-events-none flex items-center gap-2 z-10 ${
                isFocused || hasValue 
                    ? 'top-0 -translate-y-1/2 text-xs bg-white px-1 text-[#BC8B20]' 
                    : 'top-1/2 -translate-y-1/2 text-sm text-gray-500'
            }`}>
                <span>{label}</span>
                {(isFocused || hasValue) && selectedSectorLength > 0 && (
                    <span className="bg-white rounded-full px-2 py-0.5 text-xs font-medium border border-gray-400">
                        {selectedSectorLength}
                    </span>
                )}
            </div>
            
            <input
                ref={inputRef}
                type="text"
                value={sectorVal}
                onChange={(e) => setSectorVal(e.target.value)}
                onFocus={() => {
                    setIsFocused(true);
                    if (fetchedData.length > 0) {
                        setShowDropdown(true);
                    }
                }}
                onBlur={() => {
                    setTimeout(() => setIsFocused(false), 200);
                }}
                onClick={() => {
                    if (fetchedData.length > 0) {
                        setShowDropdown(true);
                    }
                }}
                className="w-full md:w-[90%] px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                placeholder=""
            />
        </div>
    );
}

export default SectorFilter;
